/* Soulmatch — register the public service worker.
   Skips registration on local dev (CRA hot reload doesn't expose /service-worker.js
   reliably from the build dir). On the deployed preview/production it registers
   and quietly self-updates on each load. */
export function register() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  // Allow disabling via query param (?nosw=1) for debugging.
  if (new URLSearchParams(window.location.search).get("nosw") === "1") return;

  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js";
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        // Periodically check for updates so users get the latest assets without a hard reload.
        try {
          reg.update();
        } catch {
          /* noop */
        }
      })
      .catch((err) => {
        if (!isLocal) {
          // Don't pollute the dev console on local environments.
          console.warn("[Soulmatch] SW registration failed:", err);
        }
      });
  });
}

export function unregister() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.unregister())
    .catch(() => null);
}
